import Vue from 'vue'
import axios from 'axios'
// import App from '../App.vue'
import qs from 'qs';
import Cookies from 'js-cookie';
// import router from '../router'

axios.defaults.baseURL = process.env.VUE_APP_URL;
//重试连接
axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;
Vue.prototype.$axios = axios;

// var vm = new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')


// 请求拦截器，对参数做处理
axios.interceptors.request.use(function (config) {
	// console.log(store.state.Authorization)
	// if()
	config.headers['X-CCXI-ADMIN-Token'] = Cookies.get('Authorization');
	return config
});

// 返回拦截器，对返回数据做处理
axios.interceptors.response.use(function (response) {
	// console.log(response)
	if (response.data.code != '1') {
		if (response.request.responseType == 'blob') {
			return response
		}
		Vue.prototype.$message({
			type: 'error',
			message: response.data.msg
		});
		// console.log(response)
		if (response.data.msg == '用户未登录') {
			// vm.$router.push({
			// 	path: '/login',
			// });
			let url = process.env.VUE_APP_JUMP_URL;
			window.open(url + '#/login', '_self')
			return
		}

		// let loading = Vue.$loading(store.state.loadingOptions);
		// loading.close()
		// console.log(response.request.responseType)

		return false
	}

	return response.data;
});


// get请求
export function get(url, data = {}) {
	return axios({
		method: 'get',
		// ...header,
		baseURL: process.env.VUE_APP_URL,
		url,
		params: data
	})
}

// //post请求
// export function post (url, data = {}) {
//   return axios.post(url, qs.stringify(data))
// }

//post请求
export function postForm(url, data, options) {
	options
	let header = {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		}
	};

	// 单独指定headers和是否转码 2019年8月21日添加 内容为以下八行
	// if (options instanceof Object) {
	//   if (options.headers) {
	//     header = {headers: options.headers}
	//   }
	// }
	// if (!(options instanceof Object) || options.notEncode === undefined) {
	//   data = qs.stringify(data, {allowDots: true})
	// } else {
	//   header = {"Content-Type": "multipart/form-data"}
	// }

	return axios({
		method: 'post',
		...header,
		url,
		// baseURL: options.baseURL,
		baseURL: process.env.VUE_APP_URL,
		data: qs.stringify(data),
		// responseType: options instanceof Object && options.responseType ? options.responseType : '',
	})
}

//post请求
export function post(url, data = {}, options) {
	options
	let header = {
		// headers: {
		//   'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		// }
	};

	// 单独指定headers和是否转码 2019年8月21日添加 内容为以下八行
	// if (options instanceof Object) {
	//   if (options.headers) {
	//     header = {headers: options.headers}
	//   }
	// }
	// if (!(options instanceof Object) || options.notEncode === undefined) {
	//   data = qs.stringify(data, {allowDots: true})
	// } else {
	//   header = {"Content-Type": "multipart/form-data"}
	// }

	return axios({
		method: 'post',
		...header,
		url,
		// baseURL: options.baseURL,
		baseURL: process.env.VUE_APP_URL,
		data,
		// responseType: options instanceof Object && options.responseType ? options.responseType : '',
	})
}

export function postfile(url, data = {}, options) {
	options
	let header = {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	};
	return axios({
		method: 'post',
		...header,
		url,
		// baseURL: options.baseURL,
		baseURL: process.env.VUE_APP_URL,
		data,
	})
}